/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Brokers_CreatedInputs */

const cs_import_stat_brokers_created = /** @type {(inputs: Import_Stat_Brokers_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Makléři vytvořeni: ${i?.count}`)
};

const en_import_stat_brokers_created = /** @type {(inputs: Import_Stat_Brokers_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brokers created: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Brokers created: {count}" |
*
* @param {Import_Stat_Brokers_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_brokers_created = /** @type {((inputs: Import_Stat_Brokers_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Brokers_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_brokers_created(inputs)
	return cs_import_stat_brokers_created(inputs)
});